import axios from 'axios';
import type { AxiosError, AxiosResponse, AxiosRequestConfig } from 'axios';
import UserService from "./user.service";
import { store } from '../../index';
import AlertService from './notification.service';
import { authExpired } from '../../modules/login/actions';
import { notificationMessage } from '../constants/notication-constants';

const {
  REACT_APP_API_HOST,
  REACT_APP_API_PORT,
  REACT_APP_API_DEBUG,
} = process.env;

if (!REACT_APP_API_HOST || !REACT_APP_API_PORT) {
  throw new Error("Please ensure you have setup your .env file");
}
export const API_HOST = `${REACT_APP_API_HOST}:${REACT_APP_API_PORT}/api/v1`;

const API_DEBUG: boolean = REACT_APP_API_DEBUG === "true";
const getHeaders = () => {
  // const token: string | null = localStorage.getItem("token");
  const token: string | null = UserService.token;
  return {
    headers: token ? { Authorization: `Bearer ${token}`} : {},
  };
};

let interceptorsInstalled = false;

export const installInterceptors = () => {
  if (interceptorsInstalled) return;
  interceptorsInstalled = true;

  axios.interceptors.request.use((config) => {
    if (API_DEBUG) {
      console.log("[API REQUEST]", config.method?.toUpperCase(), config.url)
    }
    return config;
  },
  (error) => Promise.reject(error)
  );

  axios.interceptors.response.use(
    (response) => {
      if (API_DEBUG) {
        console.log("[API RESPONSE]", response.status, response.config.url);
      }
      return response;
    },
    (error: AxiosError) => {
      const status = error.response?.status;
      const data: any = error.response?.data ;
      const url = error.config?.url;
      const skip = error.config?.skipGlobalError;
      const serverMessage = (typeof data?.error === "string" && data.error) || (typeof data?.message === "string" && data.message) || (typeof data?.detail === "string" && data.detail) || (typeof data === "string" && data) || undefined;
      const fallbackMessage = status === 400 ? notificationMessage.BAD_REQUEST :
        status === 401 ? notificationMessage.UNAUTHORIZED :
        status === 403 ? notificationMessage.FORBIDDEN_ERROR :
        status === 404 ? notificationMessage.NOT_FOUND :
        notificationMessage.REQUEST_ERROR;
      const finalMessage = serverMessage || fallbackMessage;

      if (API_DEBUG) {
        console.log("[API ERROR]", status, url, error.response?.data);
      }
      if (status === 401) {
        const isDriveCheck = url?.includes('/user/drive/check');
        if (!isDriveCheck) {
          store.dispatch(authExpired());
        }
      }
      if (!skip && status && status !== 401 && status !== 409 && status !== 404) {
        // AlertService.error("Request Error");
        AlertService.error(finalMessage);
      }
      return Promise.reject(error);
    }
  );
};

// const OnError = (error: unknown): void => {
//   const anyError = error as any;
//   const { response } = anyError;
//   // const navigate = useNavigate();
//   if (response !== undefined && response.status === 401) {
//     UserService.logout();
//     // navigate("/login");
//     history.push("/login");
//   }
//
// };

// class ApiService {
//   static get(uri: any) {
//     return axios.get(`${API_HOST}${uri}`, getHeaders()).catch(OnError);
//   }
//
//   static post(uri: any, data: any) {
//     return axios.post(`${API_HOST}${uri}`, data, getHeaders()).catch(OnError);
//   }
//
//   static put(uri: any, data: any) {
//     return axios.put(`${API_HOST}${uri}`, data, getHeaders()).catch(OnError);
//   }
//
//   static delete(uri: any) {
//     return axios.delete(`${API_HOST}${uri}`, getHeaders()).catch(OnError);
//   }
// }
class ApiService {
  static async get<T = any>(uri: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return await axios.get(`${API_HOST}${uri}`, { ...getHeaders(), ...config });
  }

  static async post<T = any>(uri: string, data: unknown, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return  await axios.post(`${API_HOST}${uri}`, data, { ...getHeaders(), ...config });
  }

  static async put<T = any>(uri: string, data?: unknown, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return await axios.put(`${API_HOST}${uri}`, data,  { ...getHeaders(), ...config });
  }

  static async delete<T = any>(uri: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return await axios.delete(`${API_HOST}${uri}`,  { ...getHeaders(), ...config });
  }
}

export default ApiService;
